function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

const razorpayPaymentHelper = async (paymentetails, onSuccess, modalClose) => {
  const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

  if (!res) {
    alert("Razorpay SDK failed to load. Are you online?");
    return;
  }


  var paymentdata = paymentetails
  const apiKeys = await fetch(`${process.env.REACT_APP_BASE_URL}/api/images`, {
    method: "get",
    headers: {
      "Access-Control-Allow-Origin":"*",
      "Content-Type": "application/json"
    }
  }).then((res) => res.json()); 
 
  Object.assign(paymentdata, { 
    key_id: apiKeys.key_id,
    key_secret: apiKeys.key_secret,
  });

  const data = await fetch(`${process.env.REACT_APP_BASE_URL}/api/razorpay/capture`, {
    method: "post",
    headers: {
      "Access-Control-Allow-Origin":"*",
      "Content-Type": "application/json",
      "x-access-token": JSON.parse(localStorage.getItem("TOKEN")),
    },
    body: JSON.stringify(paymentdata),
  }).then((res) => res.json());

  const options = {
    key: apiKeys.key_id,    
    currency: data.currency,
    amount: data.amount.toString(),
    order_id: data.id,
    name: "Clapingo Education",
    description:paymentdata.notes.paymentDetails+" Subscription (website)",
    notes: paymentdata.notes,
    handler: function (response) {
      onSuccess(response);
    },
    prefill: {
      email: paymentdata.notes.Email,
      contact: paymentdata.notes.Number,
      name: paymentdata.notes.Name,
    },
    readonly: { email: true, contact: true },
    modal: {
      ondismiss: function () {
        modalClose();
        console.log("Checkout form closed");
      },
    },
  };
  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
};

export default razorpayPaymentHelper;


